module.exports = __webpack_public_path__ + "static/media/gallery-6.e70c10f6.jpg";